"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _header = _interopRequireDefault(require("../header"));

var _axios = _interopRequireDefault(require("axios"));

var _htmlSanitizer = require("./html-sanitizer");

var _AccordionPanel = _interopRequireDefault(require("../panel/AccordionPanel"));

var _PublishConfirmationModal = _interopRequireDefault(require("./components/PublishConfirmationModal"));

var _message = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/message"));

var _SendTestEmailModal = _interopRequireDefault(require("./components/SendTestEmailModal"));

var _stateTracker = _interopRequireDefault(require("@insided/deprecated-preact-components/state-tracker"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _Metrics = _interopRequireDefault(require("./components/Metrics"));

var _utils = require("./utils");

var _flatpickr = _interopRequireDefault(require("flatpickr"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _ScheduledConfirmationModal = _interopRequireDefault(require("./components/ScheduledConfirmationModal"));

var _ChooseEmailTypePanel = _interopRequireDefault(require("./components/panels/ChooseEmailTypePanel"));

var _interfaces = require("../EmailCampaigns/interfaces");

var _VariableParser = _interopRequireDefault(require("../EmailCampaigns/VariableParser"));

var _CreateEmailContentPanel = _interopRequireDefault(require("./components/panels/CreateEmailContentPanel"));

var _ChooseRecipientsPanel = _interopRequireWildcard(require("./components/panels/ChooseRecipientsPanel"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _TimezoneSelector = require("@insided/control/uikit/TimezoneSelector");

var _UnsavedChangesModal = _interopRequireDefault(require("./components/UnsavedChangesModal"));

var _Message = require("@insided/deprecated-control/ui-components/Message");

var _EmailTypeAndRecipients = _interopRequireDefault(require("./components/panels/EmailTypeAndRecipients"));

var _DropdownBox = _interopRequireDefault(require("@insided/deprecated-control/EmailCampaigns/DropdownBox"));

var _DropdownList = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownList"));

var _buttonControlSelector = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control-selector"));

var _ScheduleModal = _interopRequireDefault(require("@insided/deprecated-control/EmailCampaigns/components/panels/ScheduleModal"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _DeleteConfirmationModal = _interopRequireDefault(require("./components/DeleteConfirmationModal"));

var _Filters = require("@insided/deprecated-control/UserOverview/Filters");

var _api = require("@insided/deprecated-control/EmailCampaigns/api");

var _Create = require("./Create.utils");

var _EventDateFormatter = _interopRequireDefault(require("@insided/deprecated-preact-components/Event/EventDateFormatter"));

var _EmailTemplateEdit = require("@insided/deprecated-control/EmailCampaigns/components/EmailTemplateEdit");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var GENERIC_ERROR_MESSAGE = 'Something went wrong, please try again.';

var Create = /*#__PURE__*/function (_StateTracker) {
  (0, _inherits2.default)(Create, _StateTracker);

  var _super = _createSuper(Create);

  function Create(props) {
    var _props$status, _props$emailCampaignI, _ref11, _props$fromEmail, _props$fromUsername, _props$fromId, _props$status$toLower, _props$status2, _props$templateConten, _props$includeCurrent, _props$isNew, _props$groups;

    var _this;

    (0, _classCallCheck2.default)(this, Create);
    _this = _super.call(this, props); // TODO: Filter out elements that are numbers

    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "initialState", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "accordionPanel", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "webmasterName", '');
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "webmasterEmail", '');
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPropChanged", function (prop, value) {
      var emailCampaign = _this.state.emailCampaign;

      _this.trackStateChange({
        emailCampaign: _objectSpread(_objectSpread({}, emailCampaign), (0, _defineProperty2.default)({}, prop, value))
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTitleChanged", function (title) {
      _this.onPropChanged('title', title);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSubjectChanged", function (value) {
      if (value) {
        _this.setState({
          subjectError: ''
        });
      }

      _this.onPropChanged('subject', (0, _Create.stripHtmlFromText)(value));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPreviewTextChanged", function (value) {
      _this.onPropChanged('previewText', (0, _Create.stripHtmlFromText)(value));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onContentChanged", function (value) {
      _this.onPropChanged('content', value);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPreviewClicked", function () {
      _this.setState({
        showCreateEmailEdit: true
      }, function () {
        var _this$accordionPanel;

        var activePanelIndex = (_this$accordionPanel = _this.accordionPanel) === null || _this$accordionPanel === void 0 ? void 0 : _this$accordionPanel.state.activePanelIndex;

        if (typeof activePanelIndex !== 'undefined') {
          var _this$accordionPanel2;

          (_this$accordionPanel2 = _this.accordionPanel) === null || _this$accordionPanel2 === void 0 ? void 0 : _this$accordionPanel2.togglePanel(activePanelIndex);
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRecipientsFilterDone", function () {
      var _this$accordionPanel3;

      (_this$accordionPanel3 = _this.accordionPanel) === null || _this$accordionPanel3 === void 0 ? void 0 : _this$accordionPanel3.togglePanel(_interfaces.SEND_EMAIL_PANEL_INDEX);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRecipientsFilterCleared", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                audienceFilters: {
                  type: 'list',
                  data: {
                    mainRoles: [],
                    customRoles: [],
                    groups: [],
                    joinDate: null,
                    lastActivity: null
                  }
                },
                hasChanged: true
              });

              _context.next = 3;
              return _this.getRecipientsCount();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onEmailCreateDone", function () {
      _this.setState({
        showCreateEmailEdit: false
      }, function () {
        var _this$accordionPanel4;

        (_this$accordionPanel4 = _this.accordionPanel) === null || _this$accordionPanel4 === void 0 ? void 0 : _this$accordionPanel4.togglePanel(_interfaces.CHOOSE_RECIPIENTS_PANEL_INDEX);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onGeneratePanelOpen", function () {
      _this.setState({
        showGenerateEmailPanel: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onGeneratePanelClose", function () {
      _this.setState({
        showGenerateEmailPanel: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onInsert", function (content) {
      _this.setState({
        emailCampaign: _objectSpread(_objectSpread({}, _this.state.emailCampaign), {}, {
          content: content
        })
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hideAlertMessage", function () {
      _this.setState({
        alertMessageType: undefined,
        alertMessage: ''
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSelectedSegment", function () {
      var _this$state = _this.state,
          audienceFilters = _this$state.audienceFilters,
          segmentGroups = _this$state.segmentGroups;
      var selectedSegment = segmentGroups === null || segmentGroups === void 0 ? void 0 : segmentGroups.flatMap(function (segmentGroup) {
        return segmentGroup.segments;
      }).find(function (segment) {
        return "".concat(segment.id) === audienceFilters.data;
      });
      return selectedSegment;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRecipientsCount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _this$state2, rolesMap, groupsMap, audienceFilters, recipientsCount, selectedSegment, _recipientsCountRespo, recipientsCountResponse;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$state2 = _this.state, rolesMap = _this$state2.rolesMap, groupsMap = _this$state2.groupsMap, audienceFilters = _this$state2.audienceFilters;

              _this.setState({
                isRecipientsCountLoading: true
              });

              if (!((0, _ChooseRecipientsPanel.isFiltersList)(audienceFilters) && rolesMap)) {
                _context2.next = 9;
                break;
              }

              _context2.next = 5;
              return (0, _api.getRecipientsCountByFilters)(audienceFilters.data, rolesMap, groupsMap);

            case 5:
              recipientsCount = _context2.sent;

              _this.setState({
                recipientsCount: recipientsCount
              });

              _context2.next = 16;
              break;

            case 9:
              if (!(0, _ChooseRecipientsPanel.isFiltersSegment)(audienceFilters)) {
                _context2.next = 16;
                break;
              }

              selectedSegment = _this.getSelectedSegment();

              if (!selectedSegment) {
                _context2.next = 16;
                break;
              }

              _context2.next = 14;
              return (0, _api.loadRecipientsCount)(selectedSegment.filters);

            case 14:
              recipientsCountResponse = _context2.sent;

              _this.setState({
                recipientsCount: (_recipientsCountRespo = recipientsCountResponse.data) === null || _recipientsCountRespo === void 0 ? void 0 : _recipientsCountRespo.totalItems
              });

            case 16:
              _this.setState({
                isRecipientsCountLoading: false
              });

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setEmailTemplate", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var res;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this.state.templateContent) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              _context3.prev = 2;
              _context3.next = 5;
              return _axios.default.get('/emailTemplate/find/1');

            case 5:
              res = _context3.sent;

              _this.setState({
                templateContent: res.data.Content,
                isUnsubscribeLinkValid: (0, _EmailTemplateEdit.checkUnsubscribeLink)(res.data.Content)
              });

              _context3.next = 12;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](2);

              _this.setState({
                alertMessageType: 'error',
                alertMessage: GENERIC_ERROR_MESSAGE
              });

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 9]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRoleSelected", function (role) {
      _this.onPropChanged('selectedRole', role);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "trackEvent", function (action) {
      var _this$state3 = _this.state,
          fromId = _this$state3.fromId,
          fromUsername = _this$state3.fromUsername,
          recipientsCount = _this$state3.recipientsCount,
          campaignType = _this$state3.campaignType;
      var _this$state$emailCamp = _this.state.emailCampaign,
          emailCampaignId = _this$state$emailCamp.emailCampaignId,
          title = _this$state$emailCamp.title,
          subject = _this$state$emailCamp.subject;
      var emailType = 'One-off email';

      if (campaignType === 'automated') {
        emailType = 'Automated email';
      }

      var payload = {
        email_campaign_id: emailCampaignId,
        email_campaign_name: title || (0, _Create.getSanitizedText)(subject),
        email_campaign_creator_id: fromId,
        email_campaign_creator_username: fromUsername,
        email_type: emailType
      };

      if (action === 'save') {
        payload = _objectSpread(_objectSpread({}, payload), {
          type: 'Email Campaign Saved'
        });
      }

      if (action === 'send') {
        payload = _objectSpread(_objectSpread({}, payload), {
          type: 'Email Campaign Sent',
          email_campaign_recipient_count: recipientsCount
        });
      }

      if (action === 'sendTestEmail') {
        payload = _objectSpread(_objectSpread({}, payload), {
          type: 'Email Campaign Test Email Sent'
        });
      }

      _publish.default.trackEvent('userevent', payload);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "archive", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var emailCampaignId, alertMessage;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              emailCampaignId = _this.state.emailCampaign.emailCampaignId;
              _context4.prev = 1;
              _context4.next = 4;
              return _axios.default.post('/emailCampaign/archive', {
                emailCampaignId: emailCampaignId
              });

            case 4:
              window.location.assign('/email/email-campaigns');
              _context4.next = 11;
              break;

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](1);

              if (_context4.t0.response.status < 500) {
                alertMessage = _context4.t0.response.data.error;
              }

              _this.setState({
                alertMessageType: 'error',
                alertMessage: alertMessage
              });

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 7]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "delete", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
      var emailCampaignId, alertMessage;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              emailCampaignId = _this.state.emailCampaign.emailCampaignId;
              _context5.prev = 1;
              _context5.next = 4;
              return _axios.default.post('/emailCampaign/delete', {
                emailCampaignId: emailCampaignId
              });

            case 4:
              window.location.assign('/email/email-campaigns');

              _this.setState({
                alertMessageType: 'success',
                alertMessage: "".concat(_this.state.emailCampaign.title, " was successfully deleted.")
              });

              _context5.next = 12;
              break;

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](1);

              if (_context5.t0.response.status < 500) {
                alertMessage = _context5.t0.response.data.error;
              }

              _this.setState({
                alertMessageType: 'error',
                alertMessage: alertMessage
              });

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 8]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSanitizedEmail", function (action) {
      var _this$state4 = _this.state,
          _this$state4$emailCam = _this$state4.emailCampaign,
          emailCampaignId = _this$state4$emailCam.emailCampaignId,
          title = _this$state4$emailCam.title,
          subject = _this$state4$emailCam.subject,
          previewText = _this$state4$emailCam.previewText,
          content = _this$state4$emailCam.content,
          schedule = _this$state4$emailCam.schedule,
          campaignType = _this$state4.campaignType;
      var sanitizedSubject = (0, _Create.getSanitizedText)(subject);
      var isSubjectMalicious = (0, _Create.checkMaliciousPayloads)(sanitizedSubject);

      if (sanitizedSubject === '') {
        _this.setState({
          showCreateEmailEdit: true
        });

        if (['sendTestEmail', 'send'].includes(action)) {
          _this.setState({
            alertMessageType: 'error',
            alertMessage: 'Please enter an email subject.'
          });

          return;
        } else {
          _this.setState({
            subjectError: 'Please enter an email subject.',
            alertMessage: undefined,
            alertMessageType: undefined
          });
        }

        if (_this.accordionPanel && _this.accordionPanel.state.activePanelIndex !== _interfaces.CHOOSE_RECIPIENTS_PANEL_INDEX) {
          var _this$accordionPanel5;

          (_this$accordionPanel5 = _this.accordionPanel) === null || _this$accordionPanel5 === void 0 ? void 0 : _this$accordionPanel5.togglePanel(_interfaces.CHOOSE_RECIPIENTS_PANEL_INDEX);
        }

        return null;
      } else if (isSubjectMalicious) {
        _this.setState({
          subjectError: 'Please enter a subject with no HTML.',
          alertMessage: 'Please enter a subject with no HTML.',
          alertMessageType: 'error'
        });

        return null;
      } else {
        _this.setState({
          subjectError: '',
          alertMessage: undefined,
          alertMessageType: undefined
        });
      }

      if (title === '') {
        var titleFromSubject = (0, _Create.getTitleFromSubject)(sanitizedSubject);

        _this.setState({
          emailCampaign: _objectSpread(_objectSpread({}, _this.state.emailCampaign), {
            emailCampaignId: emailCampaignId,
            title: titleFromSubject
          })
        });
      }

      if (title.length > 64) {
        _this.setState({
          alertMessage: 'Please enter a title with less than 64 characters.',
          alertMessageType: 'error'
        });

        return;
      }

      var sanitizedPreview = '';

      if (previewText) {
        sanitizedPreview = (0, _Create.getSanitizedText)(previewText);

        if (sanitizedPreview.length >= _utils.PREVIEW_TEXT_LENGTH) {
          _this.setState({
            alertMessage: "Please enter a preview text with less than ".concat(_utils.PREVIEW_TEXT_LENGTH, " characters."),
            alertMessageType: 'error'
          });

          return;
        }

        var isPreviewMalicious = (0, _Create.checkMaliciousPayloads)(sanitizedPreview);

        if (isPreviewMalicious) {
          _this.setState({
            alertMessage: 'Please enter a preview text with no HTML.',
            alertMessageType: 'error'
          });

          return null;
        }
      }

      var sanitizedContent = (0, _htmlSanitizer.sanitize)(new _VariableParser.default((0, _Create.removeEditorStyles)(content)).toBracketVariable().result());

      if (campaignType && action !== 'sendTestEmail') {
        if (!_this.validateSchedule(campaignType, schedule)) return null;
      }

      return {
        sanitizedSubject: sanitizedSubject,
        sanitizedPreview: sanitizedPreview,
        sanitizedContent: sanitizedContent
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSendTestEmail", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
      var sanitizedEmail, alertMessage;
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              sanitizedEmail = _this.getSanitizedEmail('sendTestEmail');

              if (sanitizedEmail) {
                _context6.next = 3;
                break;
              }

              return _context6.abrupt("return");

            case 3:
              _context6.prev = 3;
              _context6.next = 6;
              return _axios.default.post('/emailCampaign/sendTestEmail', {
                subject: sanitizedEmail === null || sanitizedEmail === void 0 ? void 0 : sanitizedEmail.sanitizedSubject,
                content: (0, _utils.addInlineStyles)(sanitizedEmail === null || sanitizedEmail === void 0 ? void 0 : sanitizedEmail.sanitizedContent),
                previewText: (0, _Create.getPreviewTextHTML)(sanitizedEmail === null || sanitizedEmail === void 0 ? void 0 : sanitizedEmail.sanitizedPreview)
              }).then(function () {
                _this.setState({
                  showSendTestEmailModal: true
                });
              });

            case 6:
              _context6.next = 12;
              break;

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](3);

              if (_context6.t0.response.status < 500) {
                alertMessage = _context6.t0.response.data.error;
              }

              _this.setState({
                alertMessageType: 'error',
                alertMessage: alertMessage
              });

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[3, 8]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onAction", /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(action) {
        var redirectToOverview,
            isScheduled,
            _this$state5,
            _this$state5$emailCam,
            emailCampaignId,
            title,
            schedule,
            fromEmail,
            fromUsername,
            fromId,
            audienceFilters,
            campaignType,
            includeCurrentlyMatchedRecipients,
            sanitizedEmail,
            sanitizedSubject,
            sanitizedPreview,
            sanitizedContent,
            emailCampaignAudienceFilters,
            emailCampaignAudienceSegments,
            emailTitle,
            emailCampaign,
            titleForCopy,
            alertMessage,
            responseCampaignId,
            _args7 = arguments;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                redirectToOverview = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : false;
                isScheduled = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : false;

                _this.setState({
                  alertMessageType: undefined,
                  showSendConfirmationModal: false,
                  sendActionPending: action === 'send'
                });

                _this$state5 = _this.state, _this$state5$emailCam = _this$state5.emailCampaign, emailCampaignId = _this$state5$emailCam.emailCampaignId, title = _this$state5$emailCam.title, schedule = _this$state5$emailCam.schedule, fromEmail = _this$state5.fromEmail, fromUsername = _this$state5.fromUsername, fromId = _this$state5.fromId, audienceFilters = _this$state5.audienceFilters, campaignType = _this$state5.campaignType, includeCurrentlyMatchedRecipients = _this$state5.includeCurrentlyMatchedRecipients;
                sanitizedEmail = _this.getSanitizedEmail(action);

                if (sanitizedEmail) {
                  _context7.next = 7;
                  break;
                }

                return _context7.abrupt("return");

              case 7:
                sanitizedSubject = sanitizedEmail.sanitizedSubject, sanitizedPreview = sanitizedEmail.sanitizedPreview, sanitizedContent = sanitizedEmail.sanitizedContent;
                emailCampaignAudienceFilters = (0, _ChooseRecipientsPanel.isFiltersList)(audienceFilters) ? (0, _Create.mapRecipientsFilterToPayload)(audienceFilters.data, _this.state.rolesMap, _this.state.groups) : {};
                emailCampaignAudienceSegments = (0, _ChooseRecipientsPanel.isFiltersSegment)(audienceFilters) ? {
                  segmentId: Number(audienceFilters.data)
                } : {};
                emailTitle = title || (0, _Create.getTitleFromSubject)(sanitizedSubject);
                emailCampaign = _objectSpread(_objectSpread({
                  emailCampaignId: emailCampaignId !== null && emailCampaignId !== void 0 ? emailCampaignId : null,
                  title: emailTitle,
                  subject: sanitizedSubject,
                  previewText: sanitizedPreview,
                  content: (0, _utils.addInlineStyles)((0, _Create.addEditorStyles)(sanitizedContent)),
                  senderEmail: fromEmail,
                  senderUsername: fromUsername,
                  senderId: fromId,
                  campaignType: isScheduled && action === 'send' ? 'scheduled' : campaignType,
                  schedule: schedule !== null && schedule !== void 0 ? schedule : null,
                  includeCurrentlyMatchedRecipients: includeCurrentlyMatchedRecipients
                }, emailCampaignAudienceFilters), emailCampaignAudienceSegments);

                if (action === 'duplicate') {
                  titleForCopy = (0, _Create.getTitleForCopy)(emailTitle);
                  emailCampaign.emailCampaignId = null;
                  emailCampaign.title = titleForCopy;
                }

                _context7.prev = 13;
                _context7.next = 16;
                return _axios.default.post("/emailCampaign/".concat(action === 'duplicate' ? 'save' : action), _objectSpread({}, emailCampaign)).then(function (res) {
                  var emailCampaignId = res.data.emailCampaignId;
                  var _this$state6 = _this.state,
                      currentContent = _this$state6.emailCampaign.content,
                      currentStatus = _this$state6.status;
                  var content = currentContent;

                  if (action === 'duplicate' && currentStatus && currentStatus.toLowerCase() !== 'draft') {
                    content = (0, _Create.removeEditorStyles)(currentContent);
                  }

                  _this.setState({
                    emailCampaign: _objectSpread(_objectSpread({}, _this.state.emailCampaign), {
                      emailCampaignId: emailCampaignId,
                      content: content,
                      title: emailCampaign.title || (0, _Create.getTitleFromSubject)(sanitizedSubject)
                    }),
                    status: action === 'duplicate' ? 'DRAFT' : _this.state.status,
                    isNew: false
                  }, function () {
                    return _this.trackEvent(action);
                  });

                  if (action === 'duplicate') {
                    _this.setState({
                      alertMessageType: 'success',
                      alertMessage: "Email campaign '".concat(_this.state.emailCampaign.title, "' has been duplicated successfully!")
                    });
                  } else {
                    var showScheduleMessage = isScheduled && action === 'send';
                    var messagesByAction = {
                      save: 'Email campaign has been saved successfully!',
                      send: showScheduleMessage ? 'The email was successfully scheduled' : 'The email was successfully sent',
                      sendTestEmail: 'Test email has been sent successfully!'
                    };

                    _this.setState({
                      alertMessageType: 'success',
                      alertMessage: messagesByAction[action]
                    });
                  } // eslint-disable-next-line no-restricted-syntax


                  // eslint-disable-next-line no-restricted-syntax
                  _this.setInitialState({
                    emailCampaign: _this.state.emailCampaign
                  });

                  if (redirectToOverview) {
                    setTimeout(function () {
                      window.location.assign('/email/email-campaigns');
                    }, 1000);
                  } else {
                    window.history.pushState(null, '', "/email/email-campaign/".concat(emailCampaignId));
                  }
                });

              case 16:
                _context7.next = 25;
                break;

              case 18:
                _context7.prev = 18;
                _context7.t0 = _context7["catch"](13);
                alertMessage = GENERIC_ERROR_MESSAGE;

                if (_context7.t0.response.status < 500) {
                  alertMessage = _context7.t0.response.data.error || _context7.t0.response.data.errors;
                }

                _this.setState({
                  alertMessageType: 'error',
                  alertMessage: alertMessage,
                  disableCTAButtonInModalOnError: true,
                  sendActionPending: false
                });

                responseCampaignId = _context7.t0.response.data.emailCampaignId;

                if (responseCampaignId) {
                  _this.setState({
                    emailCampaign: _objectSpread(_objectSpread({}, _this.state.emailCampaign), {
                      emailCampaignId: responseCampaignId,
                      title: emailCampaign.title || (0, _Create.getTitleFromSubject)(sanitizedSubject)
                    }),
                    status: action === 'duplicate' ? 'DRAFT' : _this.state.status
                  });

                  window.history.pushState(null, '', "/email/email-campaign/".concat(responseCampaignId));
                }

              case 25:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[13, 18]]);
      }));

      return function (_x) {
        return _ref7.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "validateSchedule", function (campaignType, schedule) {
      if (campaignType !== 'scheduled') return true;
      var now = new Date();

      if (!(0, _utils.isScheduleValid)(schedule, now)) {
        _this.setState({
          alertMessageType: 'error',
          alertMessage: 'Scheduled date should be at least 20 minutes from now.',
          disableCTAButtonInModalOnError: true
        });

        return false;
      }

      return true;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRecipientsSummary", function () {
      var audienceFilters = _this.state.audienceFilters;
      var isSentEmail = _this.state.status === 'SENT';

      if (!(audienceFilters !== null && audienceFilters !== void 0 && audienceFilters.data)) {
        return null;
      }

      if ((0, _ChooseRecipientsPanel.isFiltersList)(audienceFilters)) {
        return _this.getRecipientSummaryForFilters(audienceFilters.data);
      }

      if ((0, _ChooseRecipientsPanel.isFiltersSegment)(audienceFilters)) {
        var selectedSegment = _this.getSelectedSegment();

        return selectedSegment ? (0, _preact.h)("div", {
          className: "recipients-panel-meta recipient-filter__segment-summary"
        }, "Segment is ", (0, _preact.h)("span", {
          className: "segment-name"
        }, selectedSegment.title), isSentEmail && (0, _preact.h)("a", {
          rel: "noreferrer",
          target: "_blank",
          href: (0, _absoluteUrlRuntime.resolveUrl)("/users/segments/".concat(selectedSegment === null || selectedSegment === void 0 ? void 0 : selectedSegment.id)),
          "data-track-type": "click",
          "data-element-name": "View Segment link"
        }, "View Segment")) : null;
      }

      return null;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRecipientSummaryForFilters", function (recipientsFilters) {
      var _recipientsFilters$cu, _recipientsFilters$ma, _recipientsFilters$gr;

      var _this$state7 = _this.state,
          rolesMap = _this$state7.rolesMap,
          groupsMap = _this$state7.groupsMap,
          recipientsCount = _this$state7.recipientsCount,
          campaignType = _this$state7.campaignType;
      var hasCustomRole = ((_recipientsFilters$cu = recipientsFilters.customRoles) === null || _recipientsFilters$cu === void 0 ? void 0 : _recipientsFilters$cu.length) > 0;
      var hasMainRole = ((_recipientsFilters$ma = recipientsFilters.mainRoles) === null || _recipientsFilters$ma === void 0 ? void 0 : _recipientsFilters$ma.length) > 0;
      var hasGroups = ((_recipientsFilters$gr = recipientsFilters.groups) === null || _recipientsFilters$gr === void 0 ? void 0 : _recipientsFilters$gr.length) > 0;
      var joinDate = recipientsFilters.joinDate,
          lastActivity = recipientsFilters.lastActivity,
          groups = recipientsFilters.groups;
      var showRecipientsCount = campaignType === 'one-off' || campaignType === 'scheduled';
      var hasJoinDate = !!joinDate;
      var hasLastActivity = !!lastActivity;

      if (hasCustomRole || hasMainRole) {
        var _rolesMap$customRoles, _rolesMap$mainRoles;

        return (0, _preact.h)("span", {
          className: "recipients-panel-meta"
        }, showRecipientsCount && (0, _preact.h)("span", null, recipientsCount, " recipients"), hasCustomRole && (0, _preact.h)("span", {
          className: "filter-summary"
        }, "Custom role is ", (0, _utils.getListSummaryText)((_rolesMap$customRoles = rolesMap === null || rolesMap === void 0 ? void 0 : rolesMap.customRoles) !== null && _rolesMap$customRoles !== void 0 ? _rolesMap$customRoles : null, recipientsFilters.customRoles)), hasMainRole && (0, _preact.h)("span", {
          className: "filter-summary"
        }, "Primary role is ", (0, _utils.getListSummaryText)((_rolesMap$mainRoles = rolesMap === null || rolesMap === void 0 ? void 0 : rolesMap.mainRoles) !== null && _rolesMap$mainRoles !== void 0 ? _rolesMap$mainRoles : null, recipientsFilters.mainRoles)), hasGroups && (0, _preact.h)("span", {
          className: "filter-summary"
        }, "Groups is ", (0, _utils.getListSummaryText)(groupsMap !== null && groupsMap !== void 0 ? groupsMap : null, groups)), hasJoinDate && (0, _preact.h)("span", {
          className: "filter-summary"
        }, "Registration date is ", (0, _utils.getDateSummaryText)(joinDate)), hasLastActivity && (0, _preact.h)("span", {
          className: "filter-summary"
        }, "Last activity date is ", (0, _utils.getDateSummaryText)(lastActivity)));
      }

      return '';
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onEmailTypeChanged", /*#__PURE__*/function () {
      var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(value) {
        var _this$accordionPanel6;

        var audienceFilters, hasFilter, isSegmentSelected;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                audienceFilters = _this.state.audienceFilters;
                hasFilter = (0, _ChooseRecipientsPanel.hasFilters)(audienceFilters);
                isSegmentSelected = (0, _ChooseRecipientsPanel.isFiltersSegment)(audienceFilters);

                _this.setState({
                  campaignType: value,
                  selectedCampaignType: value,
                  hasChanged: true,
                  audienceFilters: value !== 'one-off' && isSegmentSelected ? {
                    type: 'list',
                    data: {
                      mainRoles: [],
                      customRoles: [],
                      groups: [],
                      joinDate: null,
                      lastActivity: null
                    }
                  } : audienceFilters
                });

                (_this$accordionPanel6 = _this.accordionPanel) === null || _this$accordionPanel6 === void 0 ? void 0 : _this$accordionPanel6.togglePanel(_interfaces.CREATE_EMAIL_CONTENT_INDEX);

                if (!(value === 'one-off' && hasFilter)) {
                  _context8.next = 8;
                  break;
                }

                _context8.next = 8;
                return _this.getRecipientsCount();

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function (_x2) {
        return _ref8.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClickPanelCallback", function () {
      var _this$accordionPanel7;

      var isRecipientStepDone = _this.state.isRecipientStepDone;

      if (((_this$accordionPanel7 = _this.accordionPanel) === null || _this$accordionPanel7 === void 0 ? void 0 : _this$accordionPanel7.state.activePanelIndex) === _interfaces.CHOOSE_RECIPIENTS_PANEL_INDEX && !isRecipientStepDone) {
        _this.setState({
          isRecipientStepDone: true
        });
      }

      _this.setState({
        showCreateEmailEdit: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showCreateEmailPanel", function () {
      var _this$accordionPanel8;

      _this.setState({
        showCreateEmailEdit: true
      });

      (_this$accordionPanel8 = _this.accordionPanel) === null || _this$accordionPanel8 === void 0 ? void 0 : _this$accordionPanel8.togglePanel(_interfaces.SEND_EMAIL_PANEL_INDEX);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showChooseRecipientsPanel", function () {
      var _this$accordionPanel9;

      (_this$accordionPanel9 = _this.accordionPanel) === null || _this$accordionPanel9 === void 0 ? void 0 : _this$accordionPanel9.togglePanel(_interfaces.CHOOSE_RECIPIENTS_PANEL_INDEX);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showChooseEmailTypePanel", function () {
      var _this$accordionPanel10;

      (_this$accordionPanel10 = _this.accordionPanel) === null || _this$accordionPanel10 === void 0 ? void 0 : _this$accordionPanel10.togglePanel(_interfaces.CHOOSE_EMAIL_TYPE_INDEX);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showSendConfirmationModal", function () {
      _this.setState({
        showSendConfirmationModal: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSchedule", function (date, time) {
      var campaign = _this.state.emailCampaign;
      var schedule = campaign.schedule || {};
      schedule.date = _flatpickr.default.formatDate(date, 'M d Y');
      schedule.time = _flatpickr.default.formatDate(time, 'h:i K');
      campaign.schedule = schedule;

      _this.setState({
        emailCampaign: campaign
      }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this.onAction('send', true, true);

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      })));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClickCancel", function () {
      var _this$state8 = _this.state,
          hasChanged = _this$state8.hasChanged,
          campaignType = _this$state8.campaignType,
          status = _this$state8.status,
          isNew = _this$state8.isNew;
      var hasCampaignTypeChanged = campaignType !== _this.props.campaignType;
      var statusLowerCase = status.toLowerCase();
      var isDraft = statusLowerCase === 'draft' || isNew;

      if (hasChanged || hasCampaignTypeChanged) {
        _this.setState({
          showUnsavedChangesModal: true
        });

        return;
      }

      if (isDraft) {
        window.location.assign('/email/email-campaigns');
      } else {
        _this.onDiscardUnsavedChangesModalChanges();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCloseUnsavedChangesModal", function () {
      _this.setState({
        showUnsavedChangesModal: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDiscardUnsavedChangesModalChanges", function () {
      var _this$props = _this.props,
          isNew = _this$props.isNew,
          campaignType = _this$props.campaignType,
          mainRoles = _this$props.mainRoles,
          customRoles = _this$props.customRoles,
          joinDate = _this$props.joinDate,
          lastActivityDate = _this$props.lastActivityDate,
          userGroups = _this$props.userGroups,
          segmentId = _this$props.segmentId;

      if (!isNew) {
        _this.setState({
          isEditEnabled: false
        });
      }

      var audienceFilters = segmentId ? {
        type: 'segment',
        data: segmentId
      } : {
        type: 'list',
        data: {
          mainRoles: mainRoles !== null && mainRoles !== void 0 ? mainRoles : null,
          customRoles: customRoles !== null && customRoles !== void 0 ? customRoles : null,
          joinDate: (0, _Create.formatDateFilterFromStorage)(joinDate),
          lastActivity: (0, _Create.formatDateFilterFromStorage)(lastActivityDate),
          groups: userGroups !== null && userGroups !== void 0 ? userGroups : null
        }
      };

      _this.setState({
        showUnsavedChangesModal: false,
        hasChanged: false,
        emailCampaign: JSON.parse(JSON.stringify(_this.initialState.emailCampaign)),
        campaignType: campaignType,
        selectedCampaignType: campaignType,
        audienceFilters: audienceFilters,
        includeCurrentlyMatchedRecipients: false
      });

      _this.restoreToInitial();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onAudienceTypeChanged", function (audienceType) {
      _this.setState({
        audienceFilters: {
          type: audienceType,
          data: null
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onAudienceFilterChanged", /*#__PURE__*/function () {
      var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(type, filter) {
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this.setState(function (currentState) {
                  var currentData = currentState.audienceFilters.data;

                  if (type === 'list' && (0, _typeof2.default)(filter) === 'object') {
                    return _objectSpread(_objectSpread({}, currentState), {}, {
                      audienceFilters: {
                        type: type,
                        data: _objectSpread(_objectSpread({}, (0, _typeof2.default)(currentData) === 'object' ? currentData : {}), {}, (0, _defineProperty2.default)({}, filter.key, filter.payload))
                      },
                      hasChanged: true
                    });
                  }

                  return _objectSpread(_objectSpread({}, currentState), {}, {
                    audienceFilters: {
                      type: type,
                      data: filter
                    },
                    hasChanged: true
                  });
                });

                _context10.next = 3;
                return _this.getRecipientsCount();

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function (_x3, _x4) {
        return _ref10.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getMessageByStatus", function () {
      var _this$state9 = _this.state,
          status = _this$state9.status,
          scheduleLocal = _this$state9.scheduleLocal;
      var statusLowerCase = status.toLowerCase();
      var checkIcon = (0, _preact.h)(_assets.default, {
        icon: "answer",
        size: 20,
        width: 20,
        height: 20
      });

      if (statusLowerCase === 'scheduled') {
        return {
          icon: checkIcon,
          message: "Scheduled to be sent on ".concat(scheduleLocal, " (").concat(_EventDateFormatter.default.timeZone(new Date()), ")")
        };
      }

      if (statusLowerCase === 'active') {
        return {
          icon: checkIcon,
          message: 'This email campaign is currently active and will send out emails until it is paused or archived.'
        };
      }

      return null;
    });

    var _customRoles = props.customRoles ? props.customRoles.filter(function (role) {
      return !(0, _Create.isNumber)(role);
    }) : null;

    var _mainRoles = props.mainRoles ? props.mainRoles.filter(function (role) {
      return !(0, _Create.isNumber)(role);
    }) : null;

    var _joinDate = props.joinDate ? (0, _Create.formatDateFilterFromStorage)(props.joinDate) : null;

    var _lastActivity = props.lastActivityDate ? (0, _Create.formatDateFilterFromStorage)(props.lastActivityDate) : null;

    var _isDraft = ((_props$status = props.status) === null || _props$status === void 0 ? void 0 : _props$status.toLowerCase()) === 'draft';

    var initialSchedule = props.schedule ? _objectSpread({}, props.schedule) : {
      date: _flatpickr.default.formatDate(new Date(), 'M d Y'),
      time: _flatpickr.default.formatDate(new Date(), 'h:i K'),
      timeZone: (0, _utils.getTimezone)(Intl.DateTimeFormat().resolvedOptions().timeZone, props.timezoneList)
    };
    var _scheduleLocal = '';

    if (props.schedule) {
      _scheduleLocal = (0, _Create.getScheduleLocal)(props.schedule);
    }

    var _audienceFilters = props.segmentId ? {
      type: 'segment',
      data: "".concat(props.segmentId)
    } : {
      type: 'list',
      data: {
        mainRoles: _mainRoles,
        customRoles: _customRoles,
        joinDate: _joinDate,
        lastActivity: _lastActivity,
        groups: props.userGroups
      }
    };

    var _previewText = props.content ? (0, _Create.getPreviewText)(props.content) : '';

    _this.state = {
      emailCampaign: {
        emailCampaignId: (_props$emailCampaignI = props.emailCampaignId) !== null && _props$emailCampaignI !== void 0 ? _props$emailCampaignI : null,
        title: props.title ? props.title : '',
        subject: props.subject ? new _VariableParser.default(props.subject).toInputVariable().result() : '',
        previewText: _previewText ? new _VariableParser.default(_previewText).toInputVariable().result() : '',
        content: (0, _Create.getContent)(props.content, props.status),
        schedule: initialSchedule
      },
      scheduleLocal: _scheduleLocal,
      recipientsCount: 0,
      isRecipientsCountLoading: false,
      isEditEnabled: _isDraft || !!props.isNew,
      isRecipientStepDone: !props.isNew,
      subjectError: '',
      showCreateEmailEdit: false,
      fromEmail: (_ref11 = (_props$fromEmail = props.fromEmail) !== null && _props$fromEmail !== void 0 ? _props$fromEmail : (0, _insidedDataStorage.getInsidedData)('user').email) !== null && _ref11 !== void 0 ? _ref11 : '',
      fromUsername: (_props$fromUsername = props.fromUsername) !== null && _props$fromUsername !== void 0 ? _props$fromUsername : (0, _insidedDataStorage.getInsidedData)('user').name,
      fromId: (_props$fromId = props.fromId) !== null && _props$fromId !== void 0 ? _props$fromId : Number((0, _insidedDataStorage.getInsidedData)('user').userid),
      status: (_props$status$toLower = (_props$status2 = props.status) === null || _props$status2 === void 0 ? void 0 : _props$status2.toLowerCase()) !== null && _props$status$toLower !== void 0 ? _props$status$toLower : 'draft',
      rolesMap: null,
      showSendConfirmationModal: false,
      showSendTestEmailModal: false,
      hasChanged: false,
      templateContent: (_props$templateConten = props.templateContent) !== null && _props$templateConten !== void 0 ? _props$templateConten : null,
      allUsers: null,
      campaignType: props.isNew ? undefined : props.campaignType,
      selectedCampaignType: props.isNew ? undefined : props.campaignType,
      showUnsavedChangesModal: false,
      includeCurrentlyMatchedRecipients: (_props$includeCurrent = props.includeCurrentlyMatchedRecipients) !== null && _props$includeCurrent !== void 0 ? _props$includeCurrent : false,
      disableCTAButtonInModalOnError: false,
      isScheduleModalOpen: false,
      isDeleteConfirmationModalOpen: false,
      isNew: (_props$isNew = props.isNew) !== null && _props$isNew !== void 0 ? _props$isNew : false,
      groups: (_props$groups = props.groups) !== null && _props$groups !== void 0 ? _props$groups : [],
      filters: null,
      groupsMap: [],
      audienceFilters: _audienceFilters,
      segmentGroups: [],
      showGenerateEmailPanel: false,
      alertMessageType: props.partial ? 'error' : undefined,
      alertMessage: props.partial ? "We're having some issues loading your campaign's metrics. We're currently working on a fix. Apologies for the inconvenience." : '',
      isUnsubscribeLinkValid: props.templateContent ? (0, _EmailTemplateEdit.checkUnsubscribeLink)(props.templateContent) : true,
      sendActionPending: false
    };
    _this.initialState = {
      emailCampaign: JSON.parse(JSON.stringify(_this.state.emailCampaign))
    };
    _this.onTitleChanged = _this.onTitleChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSubjectChanged = _this.onSubjectChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onPreviewTextChanged = _this.onPreviewTextChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onContentChanged = _this.onContentChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onAction = _this.onAction.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSendTestEmail = _this.onSendTestEmail.bind((0, _assertThisInitialized2.default)(_this));
    _this.hideAlertMessage = _this.hideAlertMessage.bind((0, _assertThisInitialized2.default)(_this));
    _this.onPreviewClicked = _this.onPreviewClicked.bind((0, _assertThisInitialized2.default)(_this));
    _this.onEmailCreateDone = _this.onEmailCreateDone.bind((0, _assertThisInitialized2.default)(_this));
    _this.onGeneratePanelOpen = _this.onGeneratePanelOpen.bind((0, _assertThisInitialized2.default)(_this));
    _this.onGeneratePanelClose = _this.onGeneratePanelClose.bind((0, _assertThisInitialized2.default)(_this));
    _this.onInsert = _this.onInsert.bind((0, _assertThisInitialized2.default)(_this));
    _this.onRoleSelected = _this.onRoleSelected.bind((0, _assertThisInitialized2.default)(_this));
    _this.onRecipientsFilterCleared = _this.onRecipientsFilterCleared.bind((0, _assertThisInitialized2.default)(_this));
    _this.getRecipientsCount = _this.getRecipientsCount.bind((0, _assertThisInitialized2.default)(_this));
    _this.onEmailTypeChanged = _this.onEmailTypeChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickPanelCallback = _this.onClickPanelCallback.bind((0, _assertThisInitialized2.default)(_this));
    _this.showCreateEmailPanel = _this.showCreateEmailPanel.bind((0, _assertThisInitialized2.default)(_this));
    _this.showChooseRecipientsPanel = _this.showChooseRecipientsPanel.bind((0, _assertThisInitialized2.default)(_this));
    _this.showChooseEmailTypePanel = _this.showChooseEmailTypePanel.bind((0, _assertThisInitialized2.default)(_this));
    _this.showSendConfirmationModal = _this.showSendConfirmationModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSchedule = _this.onSchedule.bind((0, _assertThisInitialized2.default)(_this));
    _this.getRecipientsSummary = _this.getRecipientsSummary.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeIncludeMatchingRecipients = _this.onChangeIncludeMatchingRecipients.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickCancel = _this.onClickCancel.bind((0, _assertThisInitialized2.default)(_this));
    _this.onDiscardUnsavedChangesModalChanges = _this.onDiscardUnsavedChangesModalChanges.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCloseUnsavedChangesModal = _this.onCloseUnsavedChangesModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.onRecipientsFilterDone = _this.onRecipientsFilterDone.bind((0, _assertThisInitialized2.default)(_this));
    _this.delete = _this.delete.bind((0, _assertThisInitialized2.default)(_this));
    _this.onAudienceTypeChanged = _this.onAudienceTypeChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onAudienceFilterChanged = _this.onAudienceFilterChanged.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Create, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(Create.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11() {
        var _this2 = this,
            _this$state$groups;

        var groupsMap, initialState;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                // Load initial data
                (0, _api.fetchWebmaster)().then(function (webmaster) {
                  _this2.webmasterName = webmaster.webmasterName;
                  _this2.webmasterEmail = webmaster.webmasterEmail;
                });
                groupsMap = (0, _Filters.prepareGroups)((_this$state$groups = this.state.groups) !== null && _this$state$groups !== void 0 ? _this$state$groups : []).map(function (group) {
                  return _objectSpread(_objectSpread({}, group), {}, {
                    value: "".concat(group.value)
                  });
                });
                this.setState({
                  groupsMap: groupsMap
                });
                _context11.next = 5;
                return (0, _api.loadFilters)(groupsMap).then(function (_ref12) {
                  var rolesMap = _ref12.rolesMap,
                      filters = _ref12.filters;
                  return _this2.setState({
                    rolesMap: rolesMap,
                    filters: filters
                  });
                });

              case 5:
                _context11.next = 7;
                return (0, _api.loadSegmentGroups)().then(function (segmentGroups) {
                  _this2.setState({
                    segmentGroups: segmentGroups
                  });
                });

              case 7:
                _context11.next = 9;
                return this.setEmailTemplate();

              case 9:
                (0, _get2.default)((0, _getPrototypeOf2.default)(Create.prototype), "componentDidMount", this).call(this);
                initialState = {
                  emailCampaign: this.state.emailCampaign
                };
                this.setInitialState(initialState);
                _context11.next = 14;
                return this.getRecipientsCount();

              case 14:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "onChangeIncludeMatchingRecipients",
    value: function onChangeIncludeMatchingRecipients(value) {
      this.setState({
        includeCurrentlyMatchedRecipients: value
      });
    }
  }, {
    key: "resolvePanels",
    value: function resolvePanels() {
      var _this$accordionPanel11;

      var _this$state10 = this.state,
          _this$state10$emailCa = _this$state10.emailCampaign,
          subject = _this$state10$emailCa.subject,
          previewText = _this$state10$emailCa.previewText,
          content = _this$state10$emailCa.content,
          subjectError = _this$state10.subjectError,
          showCreateEmailEdit = _this$state10.showCreateEmailEdit,
          isEditEnabled = _this$state10.isEditEnabled,
          status = _this$state10.status,
          templateContent = _this$state10.templateContent,
          campaignType = _this$state10.campaignType,
          isRecipientStepDone = _this$state10.isRecipientStepDone,
          recipientsCount = _this$state10.recipientsCount,
          isRecipientsCountLoading = _this$state10.isRecipientsCountLoading,
          selectedCampaignType = _this$state10.selectedCampaignType,
          filters = _this$state10.filters,
          audienceFilters = _this$state10.audienceFilters,
          segmentGroups = _this$state10.segmentGroups,
          showGenerateEmailPanel = _this$state10.showGenerateEmailPanel;
      var campaignLimit = this.props.campaignLimit;
      var ChooseEmailTypePanel = (0, _ChooseEmailTypePanel.default)({
        isEditEnabled: isEditEnabled,
        status: status.toLowerCase(),
        campaignType: campaignType,
        selectedCampaignType: selectedCampaignType,
        accordionActivePanel: (_this$accordionPanel11 = this.accordionPanel) === null || _this$accordionPanel11 === void 0 ? void 0 : _this$accordionPanel11.state.activePanelIndex,
        onEmailTypeChanged: this.onEmailTypeChanged,
        onClickPanelCallback: this.onClickPanelCallback
      });
      var CreateEmailContentPanel = (0, _CreateEmailContentPanel.default)({
        isEditEnabled: isEditEnabled,
        showCreateEmailEdit: showCreateEmailEdit,
        subject: subject,
        content: content,
        onSubjectChanged: this.onSubjectChanged,
        subjectError: subjectError,
        previewText: previewText,
        onPreviewTextChanged: this.onPreviewTextChanged,
        onContentChanged: this.onContentChanged,
        onEmailCreateDone: this.onEmailCreateDone,
        webmasterName: this.webmasterName,
        webmasterEmail: this.webmasterEmail,
        onPreviewClicked: this.onPreviewClicked,
        templateContent: templateContent,
        onSendTestEmail: this.onSendTestEmail,
        onGeneratePanelOpen: this.onGeneratePanelOpen,
        onGeneratePanelClose: this.onGeneratePanelClose,
        onInsert: this.onInsert,
        status: status,
        showGenerateEmailPanel: showGenerateEmailPanel
      });
      var ChooseRecipientsPanel = (0, _ChooseRecipientsPanel.default)({
        isEditEnabled: isEditEnabled,
        campaignType: campaignType,
        isDone: isRecipientStepDone,
        onClickPanelCallback: this.onClickPanelCallback,
        getRecipientsSummary: this.getRecipientsSummary,
        onRecipientsFilterCleared: this.onRecipientsFilterCleared,
        filters: filters,
        recipientsCount: recipientsCount,
        isRecipientsCountLoading: isRecipientsCountLoading,
        accordionPanel: this.accordionPanel,
        onRecipientsFilterDone: this.onRecipientsFilterDone,
        campaignLimit: campaignLimit,
        onAudienceFilterTypeChanged: this.onAudienceTypeChanged,
        onAudienceFilterChanged: this.onAudienceFilterChanged,
        audienceFilters: audienceFilters,
        segmentGroups: segmentGroups
      });

      if (!isEditEnabled) {
        return [CreateEmailContentPanel];
      }

      return [ChooseEmailTypePanel, CreateEmailContentPanel, ChooseRecipientsPanel];
    }
  }, {
    key: "resolveActionButtons",
    value: function resolveActionButtons() {
      var _this3 = this;

      var _this$state11 = this.state,
          isEditEnabled = _this$state11.isEditEnabled,
          status = _this$state11.status,
          campaignType = _this$state11.campaignType,
          emailCampaign = _this$state11.emailCampaign,
          hasChanged = _this$state11.hasChanged,
          isNew = _this$state11.isNew,
          recipientsCount = _this$state11.recipientsCount,
          audienceFilters = _this$state11.audienceFilters,
          isUnsubscribeLinkValid = _this$state11.isUnsubscribeLinkValid,
          showSendConfirmationModal = _this$state11.showSendConfirmationModal,
          sendActionPending = _this$state11.sendActionPending,
          isScheduleModalOpen = _this$state11.isScheduleModalOpen;
      var _this$props2 = this.props,
          campaignLimit = _this$props2.campaignLimit,
          isWebmasterConfigured = _this$props2.isWebmasterConfigured;
      var statusLowerCase = status.toLowerCase();
      var isAutomated = campaignType === 'automated';
      var isOneOff = campaignType === 'one-off';
      var hasFilter = (0, _ChooseRecipientsPanel.hasFilters)(audienceFilters);
      var hasContent = !!emailCampaign.subject && !!emailCampaign.content;
      var allStepsDone = hasFilter && hasContent;
      var isSaved = statusLowerCase === 'draft' && !isNew;
      var isCampaignLimitExceeded = isOneOff && recipientsCount > campaignLimit;
      var readyToBeSent = isSaved && allStepsDone && !isCampaignLimitExceeded;
      var sendButtonDisabled = !readyToBeSent || !isWebmasterConfigured || !isUnsubscribeLinkValid || showSendConfirmationModal || isScheduleModalOpen || sendActionPending;

      function getSaveButtonState() {
        if (isNew && !emailCampaign.subject) {
          return {
            disabled: true,
            tooltip: 'Enter an email subject first.'
          };
        }

        if (!isNew && !hasChanged) {
          return {
            disabled: true,
            tooltip: 'No changes to save.'
          };
        }

        return {
          disabled: false,
          tooltip: ''
        };
      }

      var saveButtonState = getSaveButtonState();
      var buttons = {
        DuplicateButton: (0, _preact.h)(_Button.default, {
          key: "duplicate-email",
          title: "Duplicate",
          size: "medium",
          onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12() {
            return _regenerator.default.wrap(function _callee12$(_context12) {
              while (1) {
                switch (_context12.prev = _context12.next) {
                  case 0:
                    _context12.next = 2;
                    return _this3.onAction('duplicate');

                  case 2:
                  case "end":
                    return _context12.stop();
                }
              }
            }, _callee12);
          })),
          "data-track-type": "click",
          "data-element-name": "Duplicate button"
        }),
        ArchiveButton: (0, _preact.h)(_Button.default, {
          key: "archive-email",
          title: "Archive",
          size: "medium",
          onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13() {
            return _regenerator.default.wrap(function _callee13$(_context13) {
              while (1) {
                switch (_context13.prev = _context13.next) {
                  case 0:
                    _context13.next = 2;
                    return _this3.archive();

                  case 2:
                    return _context13.abrupt("return", _context13.sent);

                  case 3:
                  case "end":
                    return _context13.stop();
                }
              }
            }, _callee13);
          })),
          "data-track-type": "click",
          "data-element-name": "Archive button"
        }),
        SaveButton: (0, _preact.h)(_Tooltip.default, {
          trigger: (0, _preact.h)(_Button.default, {
            key: "save-email",
            title: "Save changes",
            size: "medium",
            onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14() {
              return _regenerator.default.wrap(function _callee14$(_context14) {
                while (1) {
                  switch (_context14.prev = _context14.next) {
                    case 0:
                      _context14.next = 2;
                      return _this3.onAction('save');

                    case 2:
                      return _context14.abrupt("return", _context14.sent);

                    case 3:
                    case "end":
                      return _context14.stop();
                  }
                }
              }, _callee14);
            })),
            variant: "save",
            disabled: saveButtonState.disabled,
            "data-track-type": "click",
            "data-element-name": "Save changes button"
          }),
          tooltipMessage: saveButtonState.tooltip,
          withArrow: true,
          position: "center",
          top: 50
        }),
        CancelButton: (0, _preact.h)(_Button.default, {
          key: "discard-email",
          title: "Cancel",
          size: "medium",
          className: "qa-discard-email",
          onClick: function onClick() {
            return _this3.onClickCancel();
          },
          "data-track-type": "click",
          "data-element-name": "Cancel button"
        }),
        DeleteButton: (0, _preact.h)(_Button.default, {
          key: "delete-campaign",
          title: "Delete",
          size: "medium",
          variant: "danger",
          onClick: function onClick() {
            return _this3.setState({
              isDeleteConfirmationModalOpen: true
            });
          },
          "data-track-type": "click",
          "data-element-name": "Delete button"
        }),
        SendButton: !isAutomated ? (0, _preact.h)(_Tooltip.default, {
          trigger: (0, _preact.h)(_buttonControlSelector.default, {
            key: "send-email",
            size: "medium",
            variant: "brand",
            disabled: sendButtonDisabled,
            items: [{
              isPrincipal: true,
              title: 'Send',
              onClick: this.showSendConfirmationModal,
              variant: 'success',
              disabled: sendButtonDisabled
            }, {
              title: 'Schedule for later',
              onClick: function onClick() {
                return _this3.setState({
                  isScheduleModalOpen: true
                });
              }
            }]
          }),
          tooltipMessage: !readyToBeSent ? 'Complete all the steps and save the campaign to send it.' : '',
          withArrow: true,
          position: "center",
          top: 50
        }) : (0, _preact.h)(_Tooltip.default, {
          trigger: (0, _preact.h)(_Button.default, {
            key: "send-email",
            title: "Publish Campaign",
            size: "medium",
            onClick: this.showSendConfirmationModal,
            variant: "brand",
            disabled: !readyToBeSent || showSendConfirmationModal || sendActionPending,
            "data-track-type": "click",
            "data-element-name": "Publish Campaign button"
          }),
          tooltipMessage: !readyToBeSent ? 'Complete all the steps and save the campaign to send it.' : '',
          withArrow: true,
          position: "center",
          top: 50
        }),
        PublishButton: (0, _preact.h)(_Button.default, {
          disabled: !isWebmasterConfigured || sendActionPending,
          key: "publish-email",
          title: "Publish",
          size: "medium",
          onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15() {
            return _regenerator.default.wrap(function _callee15$(_context15) {
              while (1) {
                switch (_context15.prev = _context15.next) {
                  case 0:
                    _context15.next = 2;
                    return _this3.onAction('send');

                  case 2:
                    return _context15.abrupt("return", _context15.sent);

                  case 3:
                  case "end":
                    return _context15.stop();
                }
              }
            }, _callee15);
          })),
          variant: "brand",
          "data-track-type": "click",
          "data-element-name": "Publish button"
        }),
        ExtraOptionsButton: (0, _preact.h)(_DropdownBox.default, {
          title: (0, _preact.h)(_assets.default, {
            width: 16,
            height: 24,
            icon: "moreHoriz"
          }),
          disabled: false,
          dataElementName: "extra options dropdown"
        }, (0, _preact.h)(_DropdownList.default, {
          items: [{
            title: 'Duplicate',
            onClick: function () {
              var _onClick = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16() {
                return _regenerator.default.wrap(function _callee16$(_context16) {
                  while (1) {
                    switch (_context16.prev = _context16.next) {
                      case 0:
                        _context16.next = 2;
                        return _this3.onAction('duplicate');

                      case 2:
                        return _context16.abrupt("return", _context16.sent);

                      case 3:
                      case "end":
                        return _context16.stop();
                    }
                  }
                }, _callee16);
              }));

              function onClick() {
                return _onClick.apply(this, arguments);
              }

              return onClick;
            }()
          }, {
            title: 'Archive',
            onClick: function () {
              var _onClick2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17() {
                return _regenerator.default.wrap(function _callee17$(_context17) {
                  while (1) {
                    switch (_context17.prev = _context17.next) {
                      case 0:
                        _context17.next = 2;
                        return _this3.archive();

                      case 2:
                        return _context17.abrupt("return", _context17.sent);

                      case 3:
                      case "end":
                        return _context17.stop();
                    }
                  }
                }, _callee17);
              }));

              function onClick() {
                return _onClick2.apply(this, arguments);
              }

              return onClick;
            }()
          }, {
            title: 'Delete',
            variant: 'danger',
            onClick: function onClick() {
              return _this3.setState({
                isDeleteConfirmationModalOpen: true
              });
            }
          }],
          align: "top",
          hasSearch: false
        })),
        PauseButton: (0, _preact.h)(_Button.default, {
          key: "pause-email",
          title: "Pause",
          size: "medium",
          onClick: function onClick() {
            return alert('to implement');
          },
          variant: "success",
          "data-track-type": "click",
          "data-element-name": "Pause button"
        }),
        ResumeButton: (0, _preact.h)(_Button.default, {
          key: "resume-email",
          title: "Resume",
          size: "medium",
          onClick: function onClick() {
            return alert('to implement');
          },
          variant: "brand",
          "data-track-type": "click",
          "data-element-name": "Resume button"
        }),
        EditButton: (0, _preact.h)(_Button.default, {
          key: "edit-email",
          title: "Edit email campaign",
          size: "medium",
          onClick: function onClick() {
            return _this3.setState({
              isEditEnabled: true
            });
          },
          variant: "brand",
          "data-track-type": "click",
          "data-element-name": "Edit email campaign button"
        }),
        RescheduleButton: (0, _preact.h)(_Button.default, {
          disabled: !isWebmasterConfigured,
          key: "reschedule-email",
          title: "Reschedule",
          size: "medium",
          onClick: function onClick() {
            return _this3.setState({
              isScheduleModalOpen: true
            });
          },
          variant: "brand",
          "data-track-type": "click",
          "data-element-name": "Reschedule button"
        }),
        CloseButton: (0, _preact.h)(_Button.default, {
          key: "close-email",
          title: "Close",
          size: "medium",
          onClick: function onClick() {
            return window.location.assign('/email/email-campaigns');
          },
          "data-track-type": "click",
          "data-element-name": "Close button"
        })
      };

      if (isEditEnabled) {
        if (statusLowerCase === 'draft' && isNew) {
          return [buttons.CancelButton, buttons.SaveButton, buttons.SendButton];
        }

        if (statusLowerCase === 'draft' && !isNew) {
          return [buttons.ExtraOptionsButton, buttons.CancelButton, buttons.SaveButton, buttons.SendButton];
        }

        if (statusLowerCase === 'scheduled') {
          return [buttons.ExtraOptionsButton, buttons.CancelButton, buttons.RescheduleButton];
        }

        return [buttons.DeleteButton, buttons.CancelButton, buttons.SaveButton, buttons.SendButton];
      }

      if (statusLowerCase === 'active') {
        return [buttons.DeleteButton, buttons.CloseButton, buttons.DuplicateButton, buttons.ArchiveButton];
      }

      if (statusLowerCase === 'scheduled') {
        return [buttons.ExtraOptionsButton, buttons.EditButton];
      }

      if (statusLowerCase === 'completed') {
        return [buttons.DeleteButton, buttons.DuplicateButton, buttons.ArchiveButton];
      }

      if (statusLowerCase === 'draft') {
        return [buttons.DeleteButton, buttons.DuplicateButton, buttons.ArchiveButton, buttons.PublishButton];
      }

      if (statusLowerCase === 'archived') {
        return [buttons.DeleteButton, buttons.DuplicateButton];
      }

      if (statusLowerCase === 'paused') {
        return [buttons.DeleteButton, buttons.ResumeButton, buttons.EditButton];
      }

      return [buttons.DeleteButton, buttons.EditButton];
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props3 = this.props,
          metrics = _this$props3.metrics,
          timezoneList = _this$props3.timezoneList,
          roles = _this$props3.roles,
          groups = _this$props3.groups,
          isWebmasterConfigured = _this$props3.isWebmasterConfigured;
      var _this$state12 = this.state,
          _this$state12$emailCa = _this$state12.emailCampaign,
          title = _this$state12$emailCa.title,
          schedule = _this$state12$emailCa.schedule,
          emailCampaignId = _this$state12$emailCa.emailCampaignId,
          alertMessage = _this$state12.alertMessage,
          alertMessageType = _this$state12.alertMessageType,
          isEditEnabled = _this$state12.isEditEnabled,
          status = _this$state12.status,
          showSendConfirmationModal = _this$state12.showSendConfirmationModal,
          showSendTestEmailModal = _this$state12.showSendTestEmailModal,
          campaignType = _this$state12.campaignType,
          recipientsCount = _this$state12.recipientsCount,
          selectedCampaignType = _this$state12.selectedCampaignType,
          showUnsavedChangesModal = _this$state12.showUnsavedChangesModal,
          includeCurrentlyMatchedRecipients = _this$state12.includeCurrentlyMatchedRecipients,
          disableCTAButtonInModalOnError = _this$state12.disableCTAButtonInModalOnError,
          isScheduleModalOpen = _this$state12.isScheduleModalOpen,
          filters = _this$state12.filters,
          audienceFilters = _this$state12.audienceFilters,
          segmentGroups = _this$state12.segmentGroups,
          isUnsubscribeLinkValid = _this$state12.isUnsubscribeLinkValid,
          sendActionPending = _this$state12.sendActionPending;
      var statusLowerCase = status.toLowerCase();
      var isScheduled = statusLowerCase === 'scheduled';
      var panels = this.resolvePanels();
      var timer = alertMessageType === 'success' ? 5000 : undefined;
      var customButtons = this.resolveActionButtons();
      var displayMetrics = statusLowerCase === 'completed' || statusLowerCase === 'active' && metrics;
      var messageStatus = this.getMessageByStatus();
      return (0, _preact.h)("div", {
        className: isEditEnabled ? 'create-email-campaign' : 'create-email-campaign campaign-no-edit',
        "data-bounded-context": "Campaigns",
        "data-entity": "email-campaign-create"
      }, (0, _preact.h)(_header.default, {
        hasBreadcrumb: true,
        breadcrumbLink: "/email/email-campaigns",
        breadcrumbText: "Back to Email Campaigns",
        title: title,
        disableCancelButton: true,
        disableSaveButton: true,
        onTitleChanged: isEditEnabled ? this.onTitleChanged : undefined,
        placeholder: "Untitled Email Campaign",
        customComponent: (0, _preact.h)("div", {
          className: "email-campaign__header__buttons"
        }, customButtons),
        statusBadge: true,
        status: statusLowerCase
      }), !isWebmasterConfigured && (0, _preact.h)(_Message.Message, {
        variant: "warning",
        text: (0, _preact.h)("div", null, "Before you can start sending email campaigns, you need to set a webmaster email. Please go to the", ' ', (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)("/webmasterManagement"),
          "data-track-type": "click",
          "data-element-name": "Webmaster Email link"
        }, "Webmaster Email"), ' ', "page to verify and enable a valid email address.")
      }), !isUnsubscribeLinkValid && (0, _preact.h)(_Message.Message, {
        variant: "warning",
        text: (0, _preact.h)("div", null, 'There are issues in your email theme that need to be resolved before sending your campaign. Please fix them on the ', (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)("/email/email-template/1"),
          target: "_blank",
          rel: "noreferrer",
          "data-track-type": "click",
          "data-element-name": "Email template customise link"
        }, "Customize Theme page"), ".")
      }), !!(messageStatus !== null && messageStatus !== void 0 && messageStatus.message) && (0, _preact.h)("div", {
        className: "email-campaign__message email-campaign__message-".concat(statusLowerCase)
      }, (0, _preact.h)(_Message.Message, {
        variant: "info",
        icon: messageStatus === null || messageStatus === void 0 ? void 0 : messageStatus.icon
      }, (0, _preact.h)("span", null, messageStatus.message))), alertMessageType && (0, _preact.h)(_message.default, {
        isControl: true,
        variant: alertMessageType,
        onDismiss: this.hideAlertMessage,
        timer: timer,
        renderHTML: true,
        message: alertMessage
      }), campaignType !== 'scheduled' && emailCampaignId && displayMetrics && metrics && (0, _preact.h)(_Metrics.default, {
        metrics: metrics,
        campaignId: emailCampaignId,
        roles: roles,
        groups: groups
      }), !isEditEnabled && (0, _preact.h)(_EmailTypeAndRecipients.default, {
        campaignType: campaignType !== null && campaignType !== void 0 ? campaignType : 'one-off',
        filters: filters,
        recipientsCount: recipientsCount,
        audienceFilter: audienceFilters,
        segmentGroups: segmentGroups
      }), (0, _preact.h)(_AccordionPanel.default, {
        defaultActivePanelIndex: _interfaces.CHOOSE_EMAIL_TYPE_INDEX,
        ref: function ref(_ref17) {
          _this4.accordionPanel = _ref17;
        },
        panels: panels
      }), showSendConfirmationModal && (campaignType === 'scheduled' ? (0, _preact.h)(_ScheduledConfirmationModal.default, {
        schedule: schedule,
        isOpen: showSendConfirmationModal,
        onSend: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18() {
          return _regenerator.default.wrap(function _callee18$(_context18) {
            while (1) {
              switch (_context18.prev = _context18.next) {
                case 0:
                  _context18.next = 2;
                  return _this4.onAction('send', true);

                case 2:
                  return _context18.abrupt("return", _context18.sent);

                case 3:
                case "end":
                  return _context18.stop();
              }
            }
          }, _callee18);
        })),
        onClose: function onClose() {
          return _this4.setState({
            showSendConfirmationModal: false,
            disableCTAButtonInModalOnError: false
          });
        },
        isScheduleButtonDisabled: disableCTAButtonInModalOnError
      }) : (0, _preact.h)(_PublishConfirmationModal.default, {
        campaignType: selectedCampaignType,
        includeCurrentlyMatchedRecipients: includeCurrentlyMatchedRecipients,
        isOpen: showSendConfirmationModal,
        numberOfUsers: recipientsCount,
        onSend: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19() {
          return _regenerator.default.wrap(function _callee19$(_context19) {
            while (1) {
              switch (_context19.prev = _context19.next) {
                case 0:
                  _context19.next = 2;
                  return _this4.onAction('send', true);

                case 2:
                  return _context19.abrupt("return", _context19.sent);

                case 3:
                case "end":
                  return _context19.stop();
              }
            }
          }, _callee19);
        })),
        onClose: function onClose() {
          return _this4.setState({
            showSendConfirmationModal: false,
            disableCTAButtonInModalOnError: false
          });
        },
        isSendButtonDisabled: disableCTAButtonInModalOnError
      })), showSendTestEmailModal && (0, _preact.h)(_SendTestEmailModal.default, {
        showModal: showSendTestEmailModal,
        onClose: function onClose() {
          return _this4.setState({
            showSendTestEmailModal: false
          });
        }
      }), (0, _preact.h)(_UnsavedChangesModal.default, {
        showUnsavedChangesModal: showUnsavedChangesModal,
        closeModal: this.onCloseUnsavedChangesModal,
        resetChanges: this.onDiscardUnsavedChangesModalChanges
      }), (0, _preact.h)(_ScheduleModal.default, {
        onClose: function onClose() {
          return _this4.setState({
            isScheduleModalOpen: false
          });
        },
        schedule: schedule,
        isScheduled: isScheduled,
        isOpen: isScheduleModalOpen,
        sendActionPending: sendActionPending,
        timezoneDropdownItems: timezoneList.map(function (timezone) {
          return _objectSpread(_objectSpread({}, (0, _TimezoneSelector.timezoneToDropdownItem)(timezone)), {}, {
            onClick: function onClick(event) {
              var target = event.target;
              var attributeValue = target.getAttribute('value');
              var campaign = _this4.state.emailCampaign;
              var schedule = campaign.schedule || {};
              schedule.timeZone = (0, _utils.getTimezone)(attributeValue !== null && attributeValue !== void 0 ? attributeValue : '', timezoneList);
              campaign.schedule = schedule;

              _this4.setState({
                emailCampaign: campaign
              });
            }
          });
        }),
        onSchedule: this.onSchedule
      }), (0, _preact.h)(_DeleteConfirmationModal.default, {
        isOpen: this.state.isDeleteConfirmationModalOpen,
        onDelete: this.delete,
        onCancel: function onCancel() {
          return _this4.setState({
            isDeleteConfirmationModalOpen: false
          });
        }
      }));
    }
  }]);
  return Create;
}(_stateTracker.default);

var _default = Create;
exports.default = _default;